'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, ButtonGroup, Grid, Heading, LoadingIndicator } from '@petsmart-ui/sparky';
import { useFormikContext } from 'formik';
import { type MouseEvent, useEffect, useMemo, useState } from 'react';
import { useAlertBanner, useUserSession } from '@libs/common-next';
import { BillingAddressSelector } from '../BillingAddressSelector';
import { DEFAULT_ADDRESS_FORM_STATE, MAX_ADDRESSES } from '../PaymentForm/constants';
import type { PaymentFormInterface } from '../PaymentForm/types';
import { BillingAddressForm } from './BillingAddressForm';
import type { BillingAddressProps } from './types';
import './BillingAddress.scss';
export function BillingAddress(t0) {
  const $ = _c(64);
  const {
    onCancel,
    handleErrorBanner,
    isLoading,
    disableUntilDirty,
    addAddressIconSize: t1,
    defaultAddressId,
    hideCancelCta: t2,
    submitCtaText: t3
  } = t0;
  const addAddressIconSize = t1 === undefined ? "sm" : t1;
  const hideCancelCta = t2 === undefined ? false : t2;
  const submitCtaText = t3 === undefined ? "Save" : t3;
  const [showForm, setShowForm] = useState(false);
  const {
    userData
  } = useUserSession();
  let t4;
  if ($[0] !== userData) {
    t4 = {
      ...userData
    };
    $[0] = userData;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const {
    addresses
  } = t4;
  const {
    setAlert
  } = useAlertBanner();
  const {
    setValues,
    values,
    submitForm,
    touched,
    setTouched,
    validateForm,
    dirty
  } = useFormikContext();
  const addressListLoading = addresses === undefined;
  let t5;
  bb0: {
    if (!addresses || !defaultAddressId) {
      t5 = addresses;
      break bb0;
    }
    let t6;
    if ($[2] !== addresses || $[3] !== defaultAddressId) {
      let t7;
      if ($[5] !== defaultAddressId) {
        t7 = addr => addr.addressId.toString() === defaultAddressId;
        $[5] = defaultAddressId;
        $[6] = t7;
      } else {
        t7 = $[6];
      }
      t6 = addresses.find(t7);
      $[2] = addresses;
      $[3] = defaultAddressId;
      $[4] = t6;
    } else {
      t6 = $[4];
    }
    const selectedAddress = t6;
    let t7;
    if ($[7] !== addresses || $[8] !== defaultAddressId || $[9] !== selectedAddress) {
      let t8;
      if ($[11] !== defaultAddressId) {
        t8 = addr_0 => addr_0.addressId.toString() !== defaultAddressId;
        $[11] = defaultAddressId;
        $[12] = t8;
      } else {
        t8 = $[12];
      }
      const otherAddresses = addresses.filter(t8);
      t7 = selectedAddress ? [selectedAddress, ...otherAddresses] : addresses;
      $[7] = addresses;
      $[8] = defaultAddressId;
      $[9] = selectedAddress;
      $[10] = t7;
    } else {
      t7 = $[10];
    }
    t5 = t7;
  }
  const sortedAddresses = t5;
  let t6;
  let t7;
  if ($[13] !== addresses) {
    t6 = () => {
      if (addresses === null || addresses?.length === 0) {
        setShowForm(true);
      }
    };
    t7 = [addresses];
    $[13] = addresses;
    $[14] = t6;
    $[15] = t7;
  } else {
    t6 = $[14];
    t7 = $[15];
  }
  useEffect(t6, t7);
  const scrollToBillingSection = _temp;
  let t8;
  if ($[16] !== setTouched || $[17] !== setValues || $[18] !== touched || $[19] !== values) {
    t8 = () => {
      setValues({
        ...values,
        address: DEFAULT_ADDRESS_FORM_STATE,
        firstName: "",
        lastName: "",
        phone: "",
        addressType: "form"
      });
      setTouched({
        ...touched,
        address: false,
        firstName: false,
        lastName: false,
        phone: false
      });
      setShowForm(true);
      requestAnimationFrame(() => {
        scrollToBillingSection();
      });
    };
    $[16] = setTouched;
    $[17] = setValues;
    $[18] = touched;
    $[19] = values;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  const handleAddNewAddressClick = t8;
  let t9;
  if ($[21] !== addresses?.length || $[22] !== onCancel || $[23] !== setAlert || $[24] !== setValues || $[25] !== showForm || $[26] !== values) {
    t9 = () => {
      setAlert(null);
      if (addresses?.length && showForm) {
        setValues({
          ...values,
          addressType: "id",
          address: undefined,
          firstName: undefined,
          lastName: undefined,
          phone: undefined
        });
        setShowForm(false);
      } else {
        onCancel();
      }
    };
    $[21] = addresses?.length;
    $[22] = onCancel;
    $[23] = setAlert;
    $[24] = setValues;
    $[25] = showForm;
    $[26] = values;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  const handleCancelClick = t9;
  let t10;
  if ($[28] !== handleErrorBanner || $[29] !== setTouched || $[30] !== submitForm || $[31] !== touched || $[32] !== validateForm) {
    t10 = async e => {
      e.preventDefault();
      const validationErrors = await validateForm();
      if (Object.keys(validationErrors).length > 0) {
        const touchedFields = Object.keys(validationErrors).reduce((acc, key) => {
          const errorValue = validationErrors[key as keyof typeof validationErrors];
          if (typeof errorValue === "object" && errorValue !== null) {
            acc[key] = Object.keys(errorValue).reduce(_temp2, {} as Record<string, boolean>);
          } else {
            acc[key] = true;
          }
          return acc;
        }, {} as Record<string, boolean | Record<string, boolean>>);
        setTouched({
          ...touched,
          ...touchedFields
        }, false);
        handleErrorBanner(validationErrors);
      } else {
        const isValid = handleErrorBanner();
        if (isValid) {
          submitForm();
        }
      }
    };
    $[28] = handleErrorBanner;
    $[29] = setTouched;
    $[30] = submitForm;
    $[31] = touched;
    $[32] = validateForm;
    $[33] = t10;
  } else {
    t10 = $[33];
  }
  const handleSubmitClick = t10;
  let t11;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Heading tagName="h6" size="body-lg-bold" data-testid="billing-address-title">Billing address</Heading>;
    $[34] = t11;
  } else {
    t11 = $[34];
  }
  let t12;
  if ($[35] !== addressListLoading) {
    t12 = addressListLoading && <Grid.Item><LoadingIndicator iconSize="4xl" data-testid="loading-indicator" /></Grid.Item>;
    $[35] = addressListLoading;
    $[36] = t12;
  } else {
    t12 = $[36];
  }
  let t13;
  if ($[37] !== addAddressIconSize || $[38] !== addresses?.length || $[39] !== handleAddNewAddressClick || $[40] !== showForm || $[41] !== sortedAddresses) {
    t13 = !!sortedAddresses?.length && sortedAddresses?.length !== 0 && !showForm && <Grid.Item className="address-selector-item"><BillingAddressSelector billingAddresses={sortedAddresses} /><Button data-testid="add-address-btn" className="billing-address__add-address-btn" type="button" text="Add new address" variant="link" iconName="plus" iconSize={addAddressIconSize} iconPosition="before" disabled={(addresses?.length ?? 0) >= MAX_ADDRESSES} onClick={handleAddNewAddressClick} /></Grid.Item>;
    $[37] = addAddressIconSize;
    $[38] = addresses?.length;
    $[39] = handleAddNewAddressClick;
    $[40] = showForm;
    $[41] = sortedAddresses;
    $[42] = t13;
  } else {
    t13 = $[42];
  }
  let t14;
  if ($[43] !== showForm) {
    t14 = showForm && <Grid.Item><BillingAddressForm /></Grid.Item>;
    $[43] = showForm;
    $[44] = t14;
  } else {
    t14 = $[44];
  }
  let t15;
  if ($[45] !== handleCancelClick || $[46] !== hideCancelCta || $[47] !== isLoading) {
    t15 = !hideCancelCta && <Button disabled={isLoading} text="Cancel" size="lg" type="button" fullWidth={true} onClick={handleCancelClick} />;
    $[45] = handleCancelClick;
    $[46] = hideCancelCta;
    $[47] = isLoading;
    $[48] = t15;
  } else {
    t15 = $[48];
  }
  const t16 = isLoading || disableUntilDirty && !dirty;
  let t17;
  if ($[49] !== handleSubmitClick) {
    t17 = e_0 => {
      handleSubmitClick(e_0);
    };
    $[49] = handleSubmitClick;
    $[50] = t17;
  } else {
    t17 = $[50];
  }
  let t18;
  if ($[51] !== isLoading || $[52] !== submitCtaText || $[53] !== t16 || $[54] !== t17) {
    t18 = <Button loading={isLoading} disabled={t16} text={submitCtaText} size="lg" type="submit" variant="primary" className="billing-address__save-cta" fullWidth={true} onClick={t17} />;
    $[51] = isLoading;
    $[52] = submitCtaText;
    $[53] = t16;
    $[54] = t17;
    $[55] = t18;
  } else {
    t18 = $[55];
  }
  let t19;
  if ($[56] !== t15 || $[57] !== t18) {
    t19 = <Grid.Item><ButtonGroup behavior="responsive" className="billing-address__button-group" data-testid="billing-address-button-group">{t15}{t18}</ButtonGroup></Grid.Item>;
    $[56] = t15;
    $[57] = t18;
    $[58] = t19;
  } else {
    t19 = $[58];
  }
  let t20;
  if ($[59] !== t12 || $[60] !== t13 || $[61] !== t14 || $[62] !== t19) {
    t20 = <div className="billing-address" data-testid="billing-address">{t11}<Grid>{t12}{t13}{t14}{t19}</Grid></div>;
    $[59] = t12;
    $[60] = t13;
    $[61] = t14;
    $[62] = t19;
    $[63] = t20;
  } else {
    t20 = $[63];
  }
  return t20;
}
function _temp2(nestedAcc, nestedKey) {
  nestedAcc[nestedKey] = true;
  return nestedAcc;
}
function _temp() {
  const title = document.querySelector("[data-testid=\"billing-address\"]");
  if (title) {
    title.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  }
}